import * as React from 'react';
import _ from 'lodash';
import { Context, nav, VPage, User } from "tonva-react";
import { CUqBase } from '../CBase';
import { VMe } from './VMe';
import { CSelectShippingContact } from '../customer/CSelectContact';
import { EditMeInfoFirstOrder } from './EditMeInfoFirstOrder';
import { CInvoiceInfo } from '../customer/CInvoiceInfo';
import { CAddress } from '../customer/CAddress';
import { CFavorites } from '../customer/CFavorites';
import { VLoginState } from './VLoginState';
import { VLoginState_Web } from './VLoginState_Web';
import { VLegal } from './legal';
import { EditMeInfo } from './EditMeInfo';
import { Privacy } from './privacy';

export const noteMeUI: JSX.Element = <>
    化学品是受国家安全法规限制的特殊商品，百灵威提供技术咨询、资料以及化学产品的对象必须是具有化学管理和应用能力的专业单位（非个人）。 为此，需要您重新提供非虚拟的、可核查的信息。这些信息
    包括手机号、真实姓名、单位名称，如信息不全客服人员将电话联系您。感谢您的理解。
</>;

export class CMe extends CUqBase {
    //    cApp: CApp;
    protected async internalStart(param?: any) {
    }

    async changeWebUser(webUser: any) {
        let { currentUser } = this.cApp;
        await currentUser.changeWebUser(webUser);
    }

    async changeWebUserContact(webUserContact: any) {
        let { currentUser } = this.cApp;
        await currentUser.changeWebUserContact(webUserContact);
    }

    tab = () => this.renderView(VMe);
    tabPage: VMe = new VMe(this);

    openMyOrders = async (state: string) => {
        let { cOrder } = this.cApp;
        await cOrder.openMyOrders(state);
    }

    openContactList = async () => {
        let contactList = this.newC(CSelectShippingContact); // new CSelectShippingContact(this.cApp, undefined, false);
        await contactList.start(false);
    }

    openInvoice = async () => {
        let cInvoiceInfo = this.newC(CInvoiceInfo); // new CInvoiceInfo(this.cApp, undefined, false);
        let { currentUser } = this.cApp;
        let defaultSetting = await currentUser.getSetting();

        let origInvoice = _.pick(defaultSetting, ['invoiceType', 'invoiceInfo']);
        cInvoiceInfo.start(origInvoice);
    }

    openMyPoint = async () => {
        /* let cPointProduct = this.newC(CPointProduct);// new CSelectShippingContact(this.cApp, undefined, false);
        await cPointProduct.start(); */
        await this.cApp.cPointProduct.openMyPoint();
    }
    /**
     * 卡券管理
     */
    openCouponManage = async () => {
        let { cCoupon } = this.cApp;
        await cCoupon.openMyCouponManage();
        // let cCouponManage = this.newC(CCouponManage);
        // await cCouponManage.start();
    }

    /**
     * 商品收藏
     */
    openFavorites = async () => {
        let cMyFavorites = this.newC(CFavorites);
        await cMyFavorites.start();
    }

    toPersonalAccountInfo = async (fn: Function, note: JSX.Element, changeDefaultForm?: any) => {
        await this.openMeInfoFirstOrder({
            changeDefaultForm: changeDefaultForm,
            onlyRequired: false,
            caption: "请补充账户信息",
            note: note,
            actionButton: {
                value: "下一步",
                action: fn
            }
        });
    }

    openMeInfoFirstOrder = async (options?: any) => {
        await this.openVPage(EditMeInfoFirstOrder, options);
    }

    pickAddress = async (context: Context, name: string, value: number): Promise<number> => {
        let cAddress = this.newC(CAddress); // new CAddress(this.cApp, undefined);
        return await cAddress.call<number>();
    }

    openPrivacy = () => {
        this.openVPage(Privacy);
        // nav.showPrivacyPage();
    }

    openEditMeInfo = () => {
        this.openVPage(EditMeInfo);
    }

    openLegal = async () => {
        this.openVPage(VLegal);
    }

    getCommonText = async (textId: number) => {
        return await this.uqs.order.CommonText.load(textId);
    }

    renderLoginState() {
        return this.renderView(VLoginState);
    }

    showLogin = (callback?: (user: User) => Promise<void>) => {
        nav.showLogin(callback, true);
    }

    showLoginOut = (callback?: () => Promise<void>) => {
        nav.showLogout(callback);
    }

    renderCarLabel = () => {
        let { cCart } = this.cApp;
        return cCart.renderCartLabel();
    }

    renderLoginState_Web() {
        return this.renderView(VLoginState_Web);
    }

    renderCarLabel_Web() {
        let { cCart } = this.cApp;
        return cCart.renderCartLabel_Web();
    }
}